module.exports = __webpack_public_path__ + "2df41110fceb269b3177e52ea9872c8a.woff";